import {
    Box,
    Button,
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import {
    useQuizAssessmentQuestionDataProvider
} from "../../providers/data-provider/quiz-assessment-question.data.provider";

export function QuestionFilters({ total, onFilterChange }) {
    const [themeId, setThemeId] = useState("");
    const [ownerFilter, setOwnerFilter] = useState("");
    const [search, setSearch] = useState("");
    const [selectedTags, setSelectedTags] = useState([]);
    const [themes, setThemes] = useState([]);
    const [availableTags, setAvailableTags] = useState([]);
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const { listThemes, listTags } = useQuizAssessmentQuestionDataProvider()

    useEffect(() => {
        const t = setTimeout(() => setDebouncedSearch(search.trim()), 350);
        return () => clearTimeout(t);
    }, [search]);

    useEffect(() => {
        onFilterChange({ themeId, ownerFilter, debouncedSearch, selectedTags });
    }, [themeId, ownerFilter, debouncedSearch, selectedTags, onFilterChange]);

    useEffect(() => {
        listThemes().then(res => setThemes(res.data));
        listTags().then(res => setAvailableTags(res.data));
    }, []);

    const resetFilters = useCallback(() => {
        setThemeId("");
        setOwnerFilter("");
        setSearch("");
        setSelectedTags([]);
    }, []);

    return (
        <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <InputLabel id="theme-label">Área do direito</InputLabel>
                    <Select
                        labelId="theme-label"
                        value={themeId}
                        onChange={(e) => setThemeId(e.target.value)}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {themes.map((t) => (
                            <MenuItem key={t.id} value={t.id}>
                                {t.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <InputLabel id="owner-label">Origem</InputLabel>
                    <Select
                        labelId="owner-label"
                        value={ownerFilter}
                        onChange={(e) => setOwnerFilter(e.target.value)}
                    >
                        <MenuItem value="">Todas</MenuItem>
                        <MenuItem value="pre">Questões Juristta</MenuItem>
                        <MenuItem value="mine">Minhas Questões</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Buscar por termos no enunciado"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Ex.: jurisprudência, lei seca, caso prático…"
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <InputLabel id="tags-label">Tags</InputLabel>
                    <Select
                        labelId="tags-label"
                        multiple
                        value={selectedTags}
                        onChange={(e) => setSelectedTags(e.target.value)}
                        renderValue={(selected) => (
                            <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                                {selected.map((tag) => (
                                    <Chip key={tag} label={tag} size="small" />
                                ))}
                            </Box>
                        )}
                    >
                        {availableTags.map((tag) => (
                            <MenuItem key={tag} value={tag}>
                                {tag}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="caption" color="textSecondary">
                        Resultados: {total}
                        {debouncedSearch ? ` (busca: "${debouncedSearch}")` : ""}
                    </Typography>
                    <Button onClick={resetFilters} size="small">
                        Limpar filtros
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
}
